import { Item } from '@react-stately/collections'
import { Selection } from '@react-types/shared'
import { RevisionLevel } from 'components/BlazeCommandLine/Types'
import { ListSelect, ListSelectProps } from 'components/ListSelect/ListSelect'

interface Props extends Pick<ListSelectProps, 'selectionMode' | 'limit'> {
  onChange: (levels: Array<RevisionLevel>) => void
  selectedLevels: Array<RevisionLevel>
  inline?: boolean
}

export const RevisionLevelSelect = ({ onChange, selectedLevels }: Props) => {
  const levels = Object.values(RevisionLevel)
  const handleChange = (selection: Selection) => {
    if (!(selection instanceof Set)) return

    onChange([...selection] as RevisionLevel[])
  }

  return (
    <ListSelect selectedKeys={selectedLevels} selectionMode="single" onSelectionChange={handleChange}>
      {levels.map((level) => (
        <Item key={level}>{level}</Item>
      ))}
    </ListSelect>
  )
}
